<template>
    <div class="ffz">
        <headerNav title="食物类型" />
        <div class="top">
            <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
            <van-list
                v-model="navitem.loaded"
                :finished="navitem.loadingType == 'nomore' ? true : false"
                :finished-text="navitem.loadingType == 'nomore' ? '没有更多了' : '下拉加载更多'"
                @load="loadData"
            >
                    <div v-for="(item,index) in navitem.list" :key="index">
                       <foodcom :item="item"></foodcom>
                    </div>
                </van-list>
            </van-pull-refresh>
                 
            </div>
    </div>
</template>
<script>
export default {
   data(){
        return{
            navitem: {
                loadingType: "more",
                loaded: false,
                getparams: {
                    sorting: " sorter desc,id desc",
                    maxResultCount: 10,
                    skipCount: 0,
                    canYouEatCateId:undefined
                },
                list: [],
            },
            loading: false,
            finished: false,
            refreshing: false,
        }
    },
    created(){
        var query=this.$route.query;
        console.log(query);
        if(query.id)
        {
            this.navitem.getparams.canYouEatCateId=query.id;
        }
    },
    methods:{
        onRefresh() {
         this.loadData("refresh");
        },
        loadData(source) {
           
        let navItem = this.navitem;
        // let state = navItem.state;

        if (source === "tabChange" && navItem.loaded === true) {
            //tab切换只有第一次需要加载数据
            return;
        }
        if (navItem.loadingType === "loading" || navItem.loadingType === "nomore") {
            //防止重复加载
            if (source != "refresh") {
            return;
            }
        }
        if (source === "refresh") {
            this.navitem.list = [];
            this.navitem.getparams.skipCount = 0;
        }
        navItem.loadingType = "loading";
        var params = navItem.getparams;
        
        //加载数据
        this.ajax
            .post("/api/services/app/PhoneEat/QueryEatProductPageList", params)
            .then((x) => {
            this.navitem.getparams.skipCount += this.navitem.getparams.maxResultCount;
            let totalcount = x.result.totalCount;
            this.navitem.list = this.navitem.list.concat(x.result.items);
            //console.log(this.navList);
            // item = Object.assign(item, this.orderStateExp(item.state));
            this.navitem.loadingType =
                totalcount > this.navitem.getparams.skipCount ? "more" : "nomore";
            })
            .finally(() => {
            this.$set(this.navitem, "loaded", false);
            this.refreshing = false;
            });
        },
    }
}
</script>
<style lang="scss" scoped>
.ffz{
    font-size: 12px;
    background-color: #fff;
}
.top
{
    margin-top:5px;
    margin-left: 5px;
    margin-right:5px;
}
</style>